import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { CreateAnnouncementForm } from '../CreateAnnouncementForm'

export default function CreateAnnouncementListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`สร้างประกาศหลังบ้าน`}
					description="สร้างประกาศหลังบ้าน"
				/>
			</div>
			<Separator />
			<CreateAnnouncementForm />
		</div>
	)
}
